module.exports = __webpack_public_path__ + "img/2.203ece10.png";